<template>
  <div class="home">
    <Header></Header>
    <div class="banner">
      <div class="banner-content">
        <div class="left-banner">
          <div class="title">分布式存储</div>
          <div class="content">
            沐桦科技通过整合分散于雾计算节点（如分布广泛的家庭，数据中心等）的计算资源和⽹络、存储等资源，形成覆盖全球的分布式资源网络。依托于上述资源，沐桦科技可以提供海量雾计算设备的IP及算力、存储、带宽等资源。</div>
        </div>
        <div class="right-banner">
          <img
            class=""
            src="./../assets/cache/banner.png"
            alt="沐桦科技"
          />
        </div>
      </div>
    </div>
    <section class="advantage-wrap">
      <div class="muhua-title advantage-title">产品优势</div>
      <div class="card-content">
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/cache/cost.png"
              alt=""
            >
            <div class="card-title ">低成本</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/cache/reliable.png"
              alt=""
            >
            <div class="card-title ">高可靠</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/cache/easy.png"
              alt=""
            >
            <div class="card-title ">高可靠</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              src="./../assets/cache/capacity.png"
              alt=""
            >
            <div class="card-title ">弹性扩容</div>
          </div>
        </div>
      </div>
    </section>
    <section class="application-warp">
      <div class="muhua-title ">应用场景</div>
      <div class="card-content">
        <div class="card-wrap">
          <div class="card">
            <img
              class="border"
              src="./../assets/cache/disk.png"
              alt="沐桦科技"
            />
            <div class="help-title">网络硬盘</div>
            <div class="help-content">适用数据产生量大，需要大体量存储文件的业务。</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              class="border"
              src="./../assets/cache/copy.png"
              alt="沐桦科技"
            />
            <div class="help-title">备份归档</div>
            <div class="help-content">提供高可用和高可靠的存储解决方案来备份和归档用户的关键数据。</div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="card">
            <img
              class="border"
              src="./../assets/cache/distribution.png"
              alt="沐桦科技"
            />
            <div class="help-title">内容分发</div>
            <div class="help-content">视频、游戏等热点资源分发场景，使用分布式存储作为源站，方便就近访问资源，提升用户体验。</div>
          </div>
        </div>
      </div>
    </section>
    <section class="product-detail height-220">
      <div class="muhua-title advantage-title">了解如何使用沐桦动态分布式存储服务</div>
      <div class="detail-wrap">
        <a class="button compute disable-button">查看产品文档</a>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";

export default {
  name: "home",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      activeIndex: "2-3"
    };
  }
};
</script>

<style scoped lang="stylus">
.logo {
  width: 126px;
  height: 40px;
  margin: 10px 0;
}

.banner {
  background: #282A3C;
  width: 100%;
  height: 400px;
  display: flex;
  .banner-content {
    width: 80%;
    margin: 0 auto;
    display: flex;
    max-width: 1200px;
  }
  .left-banner {
    width: 59%;
    .title {
      margin: 121px 0 19px 0;
      font-size: 38px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #fff;
      line-height: 64px;
    }
    .content {
      width: 600px;
      height: 90px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      line-height: 23px;
      margin-bottom: 27px;
      font-size: 18px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #fff;
      line-height: 32px;
    }

    .know-more {
      width: 96px;
      height: 31px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      font-size: 11px;
      font-weight: 400;
      color: rgba(40, 42, 60, 1);
      line-height: 20px;
      text-align: center;
      line-height: 31px;
    }
  }

  .right-banner {
    width: 41%;
    img {
      height: 400px;
    }
  }
}

.advantage-wrap {
  background: rgba(255, 255, 255, 1);
  .card-content {
    display: flex;
    width: 80%;
    margin: 0 auto;
    max-width: 1200px;
    .card-wrap {
      width: 25%;
      .card {
        margin: 0 auto;
        text-align: center;
      }
      img {
        width: 144px;
        height: 144px;
        background: rgba(255, 255, 255, 1);
        margin-botton: 14px;
      }
      .card-title {
        font-size: 11px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(63, 79, 124, 1);
        line-height: 20px;
        margin: 14px 0 96px;
      }
    }
  }
}

.application-warp {
  background: rgba(248, 252, 255, 1);
  .card-content {
    display: flex;
    width: 80%;
    margin: 0 auto;
    max-width: 1200px;
    .card-wrap {
      width: 33%;
      .card {
        margin: 0 auto;
        text-align: center;
        img {
          width: 80px;
          height: 66px;
        }
        .help-title {
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(63, 79, 124, 1);
          line-height: 20px;
          margin: 18px 0 19px;
        }

        .help-content {
          margin: 18px auto 96px;
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(116, 133, 152, 1);
          line-height: 22px;
          max-width: 150px;
        }
        .button {
          width: 93px;
          height: 27px;
          background: rgba(0, 174, 239, 1);
          border-radius: 2px;
          border: 1px solid rgba(0, 174, 239, 1);
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 12px;
        }
      }
    }
  }
}
.product-detail {
  background-image: url('../assets/background/white_point.png');
  background-size: cover;

  .detail-wrap {
    display: flex;
    justify-content: center;
  }
}
</style>
